<template>
  <div class="flow-box">
    <div class="list-key" v-if="!isForNewAdd">
      {{ $locale("schedule.displayMethod") }}
      <el-radio-group v-model="flowKey">
        <el-radio label="film">{{ $locale("global.works") }}</el-radio>
        <el-radio label="screen">{{ $locale("schedule.screens") }}</el-radio>
        <el-radio label="subtitles">{{ $locale("schedule.allSubtitles") }}</el-radio>
      </el-radio-group>
    </div>

    <div class="flow-search clearfix" v-if="!isForNewAdd">
      <RemoteSelectV2
          ref="selectV2"
          type="filmForSearch"
          v-model="onSearch.filmIds"
          :formValue.sync="onSearch.filmIds"
          :list="comMovieList"
          @setList="arr => comMovieList = arr"
          :isMultiple="false"
          @change="search_fn"
          :placeholder="$locale('schedule.allWorks')"
        />
      <!-- <el-select
        :placeholder="$locale('schedule.allWorks')"
        v-model="onSearch.filmIds"
        multiple
        :filterable="true"
        @change="search_fn"
      >
        <el-option
          v-for="film in filmList"
          :key="film.id"
          :value="film.id"
          :label="film.name"
        ></el-option>
      </el-select> -->
      <el-select
        :placeholder="$locale('schedule.allScreenStandards')"
        v-model="onSearch.versions"
        multiple
        @change="search_fn"
        class="w235"
      >
        <el-option
          v-for="item in versionList"
          :key="item.id"
          :value="item.id"
          :label="item.name"
        ></el-option>
      </el-select>
      <el-select
        :placeholder="$locale('schedule.allSubtitles')"
        v-model="onSearch.subtitlesVersions"
        multiple
        @change="search_fn"
        class="w190"
      >
        <el-option
          v-for="item in subtitlesVersionOption"
          :key="item.value"
          :value="item.value"
          :label="item.text"
        ></el-option>
      </el-select>
      <el-select
        :placeholder="$locale('schedule.otherVersions')"
        v-model="onSearch.otherVersions"
        multiple
        @change="search_fn"
        class="w235"
      >
        <el-option
          v-for="item in otherVersionList"
          :key="item.id"
          :value="item.id"
          :label="item.name"
        ></el-option>
      </el-select>
      <el-select
        :placeholder="$locale('schedule.screens')"
        v-model="onSearch.houseIds"
        multiple
        @change="search_fn"
      >
        <el-option
          v-for="house in houseList"
          :key="house.id"
          :value="house.id"
          :label="house.name"
        ></el-option>
      </el-select>
      <el-select
        v-model="onSearch.freeSeat"
        :placeholder="$locale('schedule.freeSeat')"
        @change="search_fn"
        clearable
      >
        <el-option value="true" :label="$locale('global.yes')"></el-option>
        <el-option value="false" :label="$locale('global.no')"></el-option>
      </el-select>
    </div>
    <el-row v-if="!isForNewAdd">
      <el-col :span="8">
        <el-switch
          v-model="isSelectedAll"
          active-text="全部選択"
          inactive-text="全部選択解除"
          active-color="#F9DA49"
          inactive-color="#DDDDDD"
          @change="setAllHandler">
        </el-switch>
      </el-col>
      <el-col :span="16" class="ta-r">
        <el-button class="egl-btn-yellow" :disabled="injectTotalSelected === 0" @click="removeSelected">{{
          injectTotalSelected === 0 ? $locale("global.delete") : $locale("global.delete") + `(${injectTotalSelected})`
        }}</el-button>
      </el-col>
    </el-row>
    
    <div class="flowListContainer">
      <template v-for="(item, idx) in dataList">
        <FlowListItem
          :key="`flowListItem${idx}`"
          :flowKey="flowKey"
          :flowData="item"
          :showHandle="showHandle"
          :otherVersionList="otherVersionList"
          @showSoldSeatFn="showSoldSeatFn"
          @delScheduleCallBack="delScheduleCallBack"
          :isForNewAdd="isForNewAdd"
        ></FlowListItem>
      </template>
    </div>
  </div>
</template>

<script>
import { formatFilmList, formatHouseList, formatVersionList } from "@/assets/js/schedule.js";
import { deleteSchedule } from "@/helpers/service/api/schedule.js";
import FlowListItem from "./FlowListItem.vue";
import countDownAlert from "@/utils/countDownAlert";
import {
  getShceduleList_fn,
} from "@/assets/js/schedule.js";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getSimpleMovieList } from "@/helpers/service/api/common.js";

export default {
  name: "ScheduleTabFlow",
  // inject: ["setAllSelected", "totalSelected"],
  inject: {
    setAllSelected: {
      default: () => () => {}
    },
    totalSelected: {
      default: () => () => 0
    }
  },
  data() {
    return {
      flowKey: "film",
      onSearch: {
        filmIds: [],
        versions: [],
        subtitlesVersions: [],
        otherVersions: [],
        houseIds: [],
        freeSeat: "",
      },
      subtitlesVersionOption: [
        {
          text: this.$locale("global.subtitlesVersion.NONE"),
          value: "NONE"
        },
        {
          text: this.$locale("global.subtitlesVersion.SUBTITLE"),
          value: "SUBTITLE"
        },
        {
          text: this.$locale("global.subtitlesVersion.DUB"),
          value: "DUB"
        }
      ],
      list: [],
      isSelectedAll: false,
      comMovieList: [],
    };
  },
  methods: {
    search_fn() {
      this.$emit("handleFn", this.onSearch);
    },
    showSoldSeatFn(sid, movieId) {
      this.$emit("showSoldSeat", sid, movieId);
    },
    updateScheduleList(_value) {
      this.$emit("update:scheduleList", _value);
    },
    delScheduleCallBack(sid) {
      const existingDataList = [ ...this.scheduleList ];
      const resultArray = existingDataList.filter(list => list.scheduleId != sid);
      this.updateScheduleList(resultArray);
    },
    setAllHandler(val) {
      this.setAllSelected(val)
    },
    removeSelected() {
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">選択中の上映回を削除しますか？</span>`;
      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        // const ids = this.scheduleList.filter(schedule => schedule.isChecked).map(item => item.scheduleId)
        // console.log("delete!!!",ids)
        deleteSchedule({ id: this.deleteIds.join(',') }).then((res) => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.$emit('getScheduleList');
                this.$emit('resetIds');
              }
            });
          } else {
            this.$alert(res.message, {
              showClose: false,
            });
          }
        })
      });
    }
  },
  components: {
    FlowListItem,
    RemoteSelectV2,
  },
  props: {
    filmList: {
      type: Array,
      default: () => []
    },
    versionList: {
      type: Array,
      default: () => []
    },
    otherVersionList: {
      type: Array,
      default: () => []
    },
    houseList: {
      type: Array,
      default: () => []
    },
    scheduleList: {
      type: Array,
      default: () => []
    },
    showHandle: {
      type: Boolean,
      default: true
    },
    isForNewAdd: {
      type: Boolean,
      default: false,
    },
    deleteIds: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    dataList() {
      let result = [];
      switch (this.flowKey) {
      case "film":
        result = formatFilmList(this.list, this.filmList, this.subtitlesVersionOption, this.otherVersionList);
        break;
      case "screen":
        result = formatHouseList(this.scheduleList, this.filmList, this.subtitlesVersionOption);
        break;
      case "subtitles":
        result = formatVersionList(this.scheduleList, this.filmList, this.subtitlesVersionOption);
        break;
      default:
        break;
      }
      return result;
    },
    injectTotalSelected() {
      return this.totalSelected();
    }
  },
  watch: {
    scheduleList: {
      handler(newVal, oldVal) {
        this.list = newVal;
        this.isSelectedAll = newVal.every(item => item.isChecked)
      },
      immediate: true,
      deep: true
    },
  },
  mounted() {
    getSimpleMovieList({
      status: 'active',
      page: 0,
      pageSize: 20,
      approve: true,
      cinemaId: window.localStorage.getItem("cinemaId"),
      field: ["id", "name"],
      hiddenCms: false,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.comMovieList = res.data.data;
      }
    });
  },
};
</script>
<style>
.el-switch__label.is-active {
	color: #F9DA49 !important;
}
</style>
